/* @flow */

import {
  sideBarTabletWidth,
  sideBarLapWidth,
  mainTabletWidth,
  mainLapWidth,
} from 'src/shared/app/base/component/template/style/template.style';
import { topAppBarElevation } from 'src/shared/app/base/style/token/elevation';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';

export default {
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: topAppBarElevation,

    width: '100%',

    [tablet]: {
      left: sideBarTabletWidth,

      maxWidth: mainTabletWidth,
    },

    [lap]: {
      left: sideBarLapWidth,

      maxWidth: mainLapWidth,
    },
  },
};
